import * as actionTypes from './actionTypes';
import * as actions from './index';
import MediaType from 'Flow2/util/MediaFile';
import * as Metadata from 'Flow2/containers/Masterdata/Masterdata';
import { isTdk, isPMDB }
    from 'Flow2/components/CustomCollections/CustomDataControllers/CustomAppController';

export const getProjectsStart = () => {
    return {
        type: actionTypes.GET_PROJECTS_START
    };
};

export const getProjectsSuccess = (projects) => {
    return {
        type: actionTypes.GET_PROJECTS_SUCCESS,
        projects: projects
    };
};

export const getProjectsFail = (error) => {
    return {
        type: actionTypes.GET_PROJECTS_FAIL,
        error: error
    };
};

export const getProjects = () => {
    return dispatch => {
        dispatch(getProjectsStart());
        // window.flow.getProjectsByFields([{field:"projecttype", type:'!=',value:'showroom', 'order':'name'}]).then(res => { 
        window.flow.getProjectsForCurrentUser().then(res => {
            dispatch(getProjectsSuccess(res.project.elements));
            if(isTdk() || isPMDB()) {
                dispatch({ type: actionTypes.GET_DISTRIBUTIONS_BY_TYPE_SUCCESS, res: res, distType: "projects" });
            }
            //console.log(res);
        }).catch(res => {
            dispatch(getProjectsFail(res.message));
            dispatch(actions.applicationError(res.message));
        });
    };
};

export const changeProjectParent = (id,oldid,newid) => {
    return dispatch => {
        if(!oldid) {
            console.log("projectAddParent");
            window.flow.projectAddParent(id,newid).then(res => {
                dispatch(actions.getProjects());
                dispatch(actions.getProjectTree());
            }).catch(res => {
                dispatch(actions.applicationError(res.message));
            });
        } else if(newid === -1) {
            console.log("projectRemoveParent");
            window.flow.projectRemoveParent(id).then(res => {
                dispatch(actions.getProjects());
                dispatch(actions.getProjectTree());
            }).catch(res => {
                dispatch(actions.applicationError(res.message));
            });
        } else {
        console.log("changeProjectParent");
            /*window.flow.projectChangeParent(id,oldid,newid).then(res => {
                dispatch(actions.getProjects());
                dispatch(actions.getProjectTree());
            }).catch(res => {
                dispatch(actions.applicationError(res.message));
            });*/
        }
    };
};


export const getDeletedProjectsStart = () => {
    return {
        type: actionTypes.GET_DELETED_PROJECTS_START
    }
}

export const getDeletedProjectsSuccess = (projects) => {
    return {
        type: actionTypes.GET_DELETED_PROJECTS_SUCCESS,
        deletedProjects: projects
    }
};

export const getDeletedProjectsFail = (error) => {
    return {
        type: actionTypes.GET_DELETED_PROJECTS_FAIL,
        error: error
    };
};

export const getDeletedProjects = () => {
    return dispatch => {
        // dispatch(getDeletedProjectsStart());
        // window.flow.getProjectsByFields([{field:"projecttype", type:'!=',value:'showroom', 'order':'name'}]).then(res => { 
        window.flow.getProjectsByFields([{ field: "projecttype", type: '=', value: 'project_delete', 'order': 'name' }]).then(res => {
            dispatch(getDeletedProjectsSuccess(res.project.elements));
        }).catch(res => {
            dispatch(getDeletedProjectsFail(res.message));
            dispatch(actions.applicationError(res.message));
        });
    };
}

export const newProjectStart = () => {
    return {
        type: actionTypes.NEW_PROJECT_START
    }
}

export const newProjectSuccess = (project) => {
    return {
        type: actionTypes.NEW_PROJECT_SUCCESS,
        payload: { project: project }
    }
}

export const newProjectFail = (error) => {
    return {
        type: actionTypes.NEW_PROJECT_FAIL,
        error: error
    }
}


export function saveNewProjectForUpload(newProjectTitle, isPrivate) {
    return (dispatch => {
        dispatch(newProjectStart());
        window.flow.newProject({ 'name': newProjectTitle }).then(res => {
            if (isPrivate) {
                window.flow.projectSetPrivate(res.id);
            }
            dispatch(newProjectSuccess(res));
            // reload projects and  project tree
            dispatch(actions.getProjectTree());
            dispatch(actions.getProjects());

            if (res.data) dispatch(actions.setNewData({ project: res.data }));
        }).catch(res => {
            dispatch(newProjectFail(res.message));
            dispatch(actions.applicationError(res.message));
        })
    })
}


export function saveNewProject(newProjectTitle, isPrivate) {
    return (dispatch => {
        dispatch(newProjectStart());
        window.flow.newProject({ 'name': newProjectTitle }).then(res => {
            if (isPrivate) {
                window.flow.projectSetPrivate(res.id);
            }
            dispatch(newProjectSuccess(res));
            // reload projects and  project tree
            dispatch(actions.getProjectTree());
            dispatch(actions.getProjects());
        }).catch(res => {
            dispatch(newProjectFail(res.message));
            dispatch(actions.applicationError(res.message));
        })
    })
}

export const setActiveProject = (id) => {
    return ({
        type: actionTypes.SET_ACTIVE_PROJECT,
        payload: { activeProject: id }
    }
    );
}

export const getProjectById = (id) => {
    
    return (dispatch => {
        window.flow.getProjectById(id).then((res) => {

        }).catch(res => {

            if (res.type === 'login') {
                dispatch(actions.logout());
            }
        })
    }
    );
};

const addClipToProjectSuccess = (projectId, clipId, type) => {
    return {
        type: actionTypes.ADD_CLIP_TO_PROJECT_SUCCESS,
        payload: { projectId: projectId, clipId: clipId, type: type }
    }
}

const addClipToProjectStart = (projectId, clipId) => {
    return {
        type: actionTypes.ADD_CLIP_TO_PROJECT_START,
        payload: { projectId: projectId, clipId: clipId }
    }
}

const addClipToProjectFail = (projectId, clipId) => {
    return {
        type: actionTypes.ADD_CLIP_TO_PROJECT_FAIL,
        error: 'Could not add clip',
        payload: { projectId: projectId, clipId: clipId }
    }
}

export const addClipToProject = (projectId, clipId, type) => {
    return ((dispatch, getState) => {
    
        dispatch(addClipToProjectStart(projectId, clipId));
        window.flow.projectAddClip(projectId, clipId, 'addtop').then(res => {
            let state = getState();
            let _type = MediaType.getMediaType(state.clipList.clips[clipId].media, state.clipList.clips[clipId].mediafiles);
            dispatch(addClipToProjectSuccess(projectId, clipId, _type));
            //dispatch(actions.getClipsForClipList(type, projectId));
        }).catch(res => {
            console.log(res);
            dispatch(addClipToProjectFail(projectId, clipId));
        });


    });
}

const addClipsToProjectSuccess = (projectId, clipIds) => {
    return {
        type: actionTypes.ADD_CLIPS_TO_PROJECT_SUCCESS,
        payload: { projectId: projectId, clipIds: clipIds }
    }
}

const addClipsToProjectStart = (projectId, clipIds) => {
    return {
        type: actionTypes.ADD_CLIPS_TO_PROJECT_START,
        payload: { projectId: projectId, clipIds: clipIds }
    }
}

const addClipsToProjectFail = (projectId, clipIds) => {
    return {
        type: actionTypes.ADD_CLIPS_TO_PROJECT_FAIL,
        error: 'Could not add clips',
        payload: { projectId: projectId, clipIds: clipIds }
    }
}

export const addClipsToProject = (projectId, clipIds, type) => {
    return ((dispatch, getState) => {
        console.log('-----------------addClipToProject',projectId, clipIds, type);
        dispatch(addClipsToProjectStart(parseInt(projectId), clipIds));
        window.flow.projectAddClip(projectId, clipIds, 'addtop').then(res => {
            let state = getState();
            dispatch(addClipsToProjectSuccess(projectId, clipIds));
            //dispatch(actions.getClipsForClipList(type, projectId));
        }).catch(res => {
            console.log(res);
            dispatch(addClipsToProjectFail(projectId, clipIds));
            dispatch(actions.addMessage('popup.title.project.add.fail', null, 'text', 'dialog'));
        });
    });
}

export const addRemoteClipsToProject = (projectId, device, clipIds) => {
    return (dispatch) => {
        //dispatch(clipListDownloadStart(clipListId));
        window.flow.newProcess('soapclient', 'Flow2 flow2flow', {
            parameters: {
                action: 'importidlist',
                clipids: clipIds,
                remoteserverdevice: device,
                addtoproject: projectId,
            }
        }).then(res => {
            var interval = setInterval(function () {
                window.flow.getProcess(res.processid).then(p => {
                    //console.log(p);
                    //console.log(p.getStatus());
                    if (p.getStatus() == 'done') {
                        console.log("DONE");
                        clearInterval(interval);
                        //dispatch(clipListDownloadSuccess(clipListId, p.outputfileurl));
                    } else if (p.getStatus() == 'error') {
                        console.log("ERROR");
                        clearInterval(interval);
                        //dispatch(clipListDownloadFail('error', clipListId));
                    }
                })

            }, 10000);
        }).catch((res) => {
            console.log(res);
            //dispatch(clipListDownloadFail(res.message));
        });
    }
}

const removeClipFromProjectSuccess = (projectId, clipId, type) => {
    return {
        type: actionTypes.REMOVE_CLIP_FROM_PROJECT_SUCCESS,
        payload: { projectId: projectId, clipId: clipId, type: type }
    }
}

const removeClipFromProjectStart = (projectId, clipId) => {
    return {
        type: actionTypes.REMOVE_CLIP_FROM_PROJECT_START,
        payload: { projectId: projectId, clipId: clipId }
    }
}

const removeClipFromProjectFail = (projectId, clipId) => {
    return {
        type: actionTypes.REMOVE_CLIP_FROM_PROJECT_FAIL,
        error: 'Could not remove clip',
        payload: { projectId: projectId, clipId: clipId }
    }
}

export const removeClipFromProject = (projectId, clipId, type) => {
    return ((dispatch, getState) => {
        dispatch(removeClipFromProjectStart(projectId, clipId));
        window.flow.projectRemoveClipById(projectId, clipId).then(res => {
            let state = getState();
            let type = MediaType.getMediaType(state.clipList.clips[clipId].media, state.clipList.clips[clipId].mediafiles);
            dispatch(removeClipFromProjectSuccess(projectId, clipId, type));
            //dispatch(actions.addMessage('Clip wurde aus Projekt entfernt', null, 'text', 'dialog'));
            // reload cliplist
            dispatch(actions.getClipsForClipList(Metadata.OBJECT_TYPE_PROJECT, projectId));
        }).catch(res => {
            console.log(res);
            dispatch(removeClipFromProjectFail(projectId, clipId));
            //dispatch(actions.addMessage('Entfernen aus Projekt fehlgeschlagen', null, 'text', 'dialog'));
        });
    });
}

const removeClipsFromProjectSuccess = (projectId, clipIds) => {
    return {
        type: actionTypes.REMOVE_CLIPS_FROM_PROJECT_SUCCESS,
        payload: { projectId: projectId, clipIds: clipIds }
    }
}

const removeClipsFromProjectStart = (projectId, clipIds) => {
    return {
        type: actionTypes.REMOVE_CLIPS_FROM_PROJECT_START,
        payload: { projectId: projectId, clipIds: clipIds }
    }
}

const removeClipsFromProjectFail = (projectId, clipIds) => {
    return {
        type: actionTypes.REMOVE_CLIPS_FROM_PROJECT_FAIL,
        error: 'Could not remove clips',
        payload: { projectId: projectId, clipIds: clipIds }
    }
}

export const removeClipsFromProject = (projectId, clipIds) => {
    return ((dispatch, getState) => {
        dispatch(removeClipsFromProjectStart(projectId, clipIds));
        window.flow.projectRemoveClipById(projectId, clipIds).then(res => {
            dispatch(removeClipsFromProjectSuccess(projectId, clipIds));
            // reload projects and  project tree
            dispatch(actions.getProjectTree());
            dispatch(actions.getProjects());
            dispatch(actions.addMessage('popup.title.project.remove.success', null, 'text', 'dialog'));
        }).catch(res => {
            console.log(res);
            dispatch(removeClipsFromProjectFail(projectId, clipIds));
            dispatch(actions.addMessage('popup.title.project.remove.fail', null, 'text', 'dialog'));
        });
    });
}

export const deleteProject = (projectId) => {
    return (dispatch => {
        dispatch({ type: actionTypes.DELETE_PROJECT_START });
        window.flow.delProject(projectId).then(res => {
            dispatch(actions.addMessage('popup.title.project.delete.success', null, 'text', 'dialog'));
            dispatch({ type: actionTypes.DELETE_PROJECT_SUCCESS, payload: { projectId: projectId } });
        }).catch(res => {
            dispatch(actions.addMessage('popup.title.project.delete.fail', null, 'text', 'dialog'));
            dispatch({ type: actionTypes.DELETE_PROJECT_FAIL });
        });
    });
}

export const removeProjectLinks = (projectId) => {
    return (dispatch => {
        dispatch({ type: actionTypes.PROJECT_REMOVE_LINKS_START });
        console.log("LAMTEST removeProjectLinks", projectId);
        window.flow.projectRemoveLinks(projectId).then(res => {
            console.log("LAMTEST removeProjectLinks res", res);
            dispatch({ type: actionTypes.PROJECT_REMOVE_LINKS_SUCCESS });
        }).catch(res => {
            dispatch({ type: actionTypes.PROJECT_REMOVE_LINKS_FAIL });
        });
    });
}

const copyProjectStart = () => {
    return {
        type: actionTypes.COPY_PROJECT_START
    }
}

const copyProjectSuccess = (project, pType = 'project') => {
    return {
        type: actionTypes.COPY_PROJECT_SUCCESS,
        payload: { project: project, type: pType }
    }
}

const copyProjectFail = (error) => {
    return {
        type: actionTypes.COPY_PROJECT_FAIL,
        error: error
    }
}

export const copyProjectAsRoom = (project) => {
    return ((dispatch, getState) => {
        dispatch(copyProjectStart());
        let name = project.name;
        let cliplist = getState().clipList.clipLists[project.id];
        let clips = cliplist ? cliplist.clips.join() : null;
        window.flow.newShowroom({ title: name }).then(res => {
            window.flow.projectAddClip(res.id, clips, 'forceadd').then((r1) => {
                //console.log(r1);
                dispatch(copyProjectSuccess(res, 'room'));
                dispatch(actions.getRooms());
                dispatch(actions.addMessage('popup.title.project.copy.success'));
            });

        }).catch(res => {
            dispatch(copyProjectFail(res.message));
            dispatch(actions.applicationError(res.message));
        });
    });
}

const getProjectIds = (project) => {
    let ids = [ ];
    if(project) {
        // set own id
        ids.push(project.getId());
        
        if(project.children && project.children.length) {
            // add child ids
            project.children.forEach(child => {
                let childIds = getProjectIds(child);
                ids = ids.concat(childIds);
            });
        }
    }
    return ids;
}

export const deleteProjects = (project, recursive = true) => {
    return (dispatch => {
        if(project) {
            const ids = (recursive && getProjectIds(project)) || [ project.getId() ];
            
            window.flow.delProject(ids.join(',')).then(res => {
                dispatch(actions.addMessage('popup.title.project.delete.success', null, 'text', 'dialog'));
                // reload projects and  project tree
                dispatch(actions.getProjects());
                dispatch(actions.getProjectTree());
            }).catch(res => {
                dispatch(actions.addMessage('popup.title.project.delete.fail', null, 'text', 'dialog'));
            });
        }
    });
}

